import { render, staticRenderFns } from "./FormLogoAndCarousel.vue?vue&type=template&id=f81a4b92&"
import script from "./FormLogoAndCarousel.vue?vue&type=script&lang=js&"
export * from "./FormLogoAndCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VDivider,VFlex,VLayout,VSelect,VSnackbar})
